export const GOOGLE_CLIENT_ID = import.meta.env.REACT_APP_GOOGLE_CLIENT_ID || '';
export const GOOGLE_RECAPTCHA = import.meta.env.REACT_APP_GOOGLE_RECAPTCHA || '';
export const CASHFREE_URL = import.meta.env.REACT_APP_CASHFREE_URL || '';
export const GOOGLE_CLIENT_SECRET = import.meta.env.REACT_APP_GOOGLE_CLIENT_SECRET || '';
export const MICROSOFT_CLIENT_ID = import.meta.env.REACT_APP_MICROSOFT_CLIENT_ID || '';
export const GOOGLE_ANALYTICS_TRACKING_CODE = import.meta.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_CODE || '';
export const MIXPANEL = import.meta.env.REACT_APP_MIXPANEL || '';
export const TARTAN_TEST = import.meta.env.REACT_APP_TARTAN_TEST || '';
export const MAIN_SITE_URL = 'https://www.healthysure.in';
export const BS_SITE_URL = 'https://www.bharatsure.com';
export const API_URL = import.meta.env.REACT_APP_API_URL || '';
export const API_V1_URL = API_URL + 'api/v1/';
export const SOCKET_URL = import.meta.env.REACT_APP_SOCKET_URL || '';
export const SECONDBRAIN_API_URL = import.meta.env.REACT_APP_SECONDBRAIN_API_URL || '';
export const BASE_PAYMENT_REDIRECT_URL = import.meta.env.REACT_APP_BASE_PAYMENT_REDIRECT_URL || '';
export const ORGANISATION_ID = import.meta.env.REACT_APP_ORGANISATION_ID || '';
export const EVEN_WEB_URL = import.meta.env.REACT_APP_EVEN_WEB_URL || 'https://even-app.staging.even.in';
export const HUBBLE_SDK_URL = import.meta.env.REACT_APP_HUBBLE_SDK_URL || '';
export const HUBBLE_CLIENT_ID = import.meta.env.REACT_APP_HUBBLE_CLIENT_ID || '';
export const HUBBLE_APP_SECRET =
  import.meta.env.REACT_APP_HUBBLE_APP_SECRET || '';
export const DEFAULT_PAGE_SIZE = '10';
export const COUNTRY = 'IN';
export const COUNTRY_CODES = { IN: '+91' } as any;
export const CURRENCY_SYMBOL = '₹';
export const LOCALE = 'en-IN';
export const COUNTRY_CODE = COUNTRY_CODES[COUNTRY];
export const FAMILY_MEMBER_PRIORITY = [
  'SELF',
  'SPOUSE',
  'CHILD',
  'DAUGHTER',
  'SON',
  'PARENT',
  'MOTHER',
  'FATHER',
  'PARENT_IN_LAW',
  'PARENTS_IN_LAW',
  'PARENTS/PARENTS_IN_LAW',
  'MOTHER_IN_LAW',
  'FATHER_IN_LAW',
];
export const BROKERSWITHINTEGRATION = ['healthysure', 'oneassure', 'even', 'covrzy'];
export const PUBLIC_INFO_PAGES = ['privacy-policy', 'terms-and-conditions'];

//retail
export const MAIN_SITE_URL_ENQUIRY = 'https://healthysure.in/how-it-works/?source=HnW&campaign_id=';
export const BRAND_NAME = 'Healthysure';
export const RETAIL_GOOGLE_ANALYTICS_TRACKING_CODE = 'G-2MM8BS6NHL';
export const REACT_APP_GA = import.meta.env.REACT_APP_GA || '';
export const MIXPANEL_TOKEN = import.meta.env.REACT_APP_MIXPANEL_TOKEN || '';
export const HDFCCOUPON = 'HDFCSURE';
export const DEXTERCOUPON = 'DEXTER2023';
export const DEXTERSLUG = 'dexter-angels';
export const MAX_ORP_PLAN_CHAR_LENGTH = 13;

export const CONFIRMATION_TYPES = {
  SELF: 'SELF',
  DEPENDENT: 'DEPENDENT',
} as const;
